// // ClientViewSidebar

// import React, { useState } from "react";
// import Box from "@mui/material/Box";
// import SwipeableDrawer from "@mui/material/SwipeableDrawer";
// import Drawer from "@mui/material/Drawer";
// import List from "@mui/material/List";
// import Divider from "@mui/material/Divider";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import Typography from "@mui/material/Typography";
// import Avatar from "@mui/material/Avatar";
// import IconButton from "@mui/material/IconButton";
// import Collapse from "@mui/material/Collapse";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
// import DialogTitle from "@mui/material/DialogTitle";
// import Button from "@mui/material/Button";
// import CircularProgress from "@mui/material/CircularProgress";
// import Tooltip from "@mui/material/Tooltip";
// import DashboardIcon from "@mui/icons-material/Dashboard";
// import PeopleIcon from "@mui/icons-material/People";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import SmsIcon from "@mui/icons-material/Sms";
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import MasksIcon from "@mui/icons-material/Masks";
// import HealingIcon from "@mui/icons-material/Healing";
// import Diversity3Icon from "@mui/icons-material/Diversity3";
// import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
// import ExpandMore from "@mui/icons-material/ExpandMore";
// import ExpandLess from "@mui/icons-material/ExpandLess";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import LanguageIcon from '@mui/icons-material/Language';
// import MenuIcon from "@mui/icons-material/Menu";
// import EmailIcon from '@mui/icons-material/Email';
// import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
// import ClinicLogo from "../../Assets/logo.png";
// import {
//   getDecryptedData,
//   getDecryptedUserType,
// } from "../../Utils/LoginUserDetails.js/LoginUserSavedDetails";

// const SIDEBAR_BG = "#122b2a";
// const SIDEBAR_HOVER = "#1a3d3b";
// const SIDEBAR_ACTIVE = "#1c7c6c";
// const SIDEBAR_TEXT = "rgba(255,255,255,0.7)";
// const SIDEBAR_TEXT_ACTIVE = "#fff";
// const SIDEBAR_BORDER = "rgba(255,255,255,0.08)";
// const TEAL_ACCENT = "#2ec4a5";

// const DESKTOP_BP = "(min-width:1200px)";
// const TABLET_BP = "(min-width:768px) and (max-width:1199px)";
// const MOBILE_BP = "(max-width:767px)";

// export default function ClientViewSidebar({ onSidebarChange }) {

//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [collapsed, setCollapsed] = useState(false);
//   const [openSection, setOpenSection] = useState(null);
// const clientId = sessionStorage.getItem("activeClientId");

//   const isDesktop = useMediaQuery(DESKTOP_BP);
//   const isTablet = useMediaQuery(TABLET_BP);
//   const isMobile = useMediaQuery(MOBILE_BP);

//   const location = useLocation();
//   const navigate = useNavigate();


//   const LoginUserDetails = getDecryptedData();
//   const LoginUserType = getDecryptedUserType();
// const client = JSON.parse(sessionStorage.getItem("clientDetails"));
// console.log("Client Details in Sidebar:", client);
//   const fullName = `${client?.legal_name || ""}`.trim();

//   /* ================= ROLE BASE PATH ================= */

//   const roleBase = {
//     super_admin: "/client-view",
//     admin: "/client-view",
//     manager: "/client-view",
//     marketer: "/client-view",
//     staff: "/client-view",
//     developer: "/client-view",
//   };

//   const basePath = roleBase[LoginUserType] || "/client-view";

//   const isCollapsed = isTablet ? true : collapsed;
//   const drawerWidth = isCollapsed ? 64 : 240;

//   React.useEffect(() => {
//     if (onSidebarChange) {
//       if (isMobile) onSidebarChange(0);
//       else onSidebarChange(drawerWidth);
//     }
//   }, [drawerWidth, isMobile, onSidebarChange]);

//   const handleLogoutConfirm = () => {
//     setLoading(true);
//     setTimeout(() => {
//       sessionStorage.clear();
//       navigate("/rite-admin-signin");
//     }, 2000);
//   };

//   const isActive = (path) => location.pathname === path;

//   /* ================= MENU ITEMS ================= */
//   const commonItems = [
//     { text: "Dashboard", icon: <DashboardIcon />, path: `${basePath}/${clientId}/dashboard` },
//     { text: "Locations", icon: <LocationOnIcon />, path: `${basePath}/locations/${clientId}` },
//     { text: "Staff", icon: <PeopleIcon />, path: `${basePath}/staff/${clientId}` },
//     { text: "Orders", icon: <CalendarMonthIcon />, path: `${basePath}/orders/${clientId}` },
//     { text: "Emails", icon: <EmailIcon />, path: `${basePath}/emails/${clientId}` },
//     { text: "RCS", icon: <SmsIcon />, path: `${basePath}/rcs/${clientId}` },
//     { text: "Websites", icon: <LanguageIcon />, path: `${basePath}/websites/${clientId}` },
//   ];

//   const riteItems = [
//     { text: "Rite Staff", path: `${basePath}/rite-staff`, icon: <MasksIcon /> },
//     { text: "Rite Departments", path: `${basePath}/rite-departments`, icon: <HealingIcon /> },
//     { text: "Rite Categories", path: `${basePath}/rite-categories`, icon: <ChevronRightIcon /> },
//   ];

//   /* ================= NAV ITEM ================= */

//   const NavItem = ({ item }) => {

//     const button = (
//       <ListItem disablePadding sx={{ mb: 0.25 }}>
//         <ListItemButton
//           component={Link}
//           to={item.path}
//           onClick={() => isMobile && setMobileOpen(false)}
//           sx={{
//             borderRadius: "8px",
//             mx: isCollapsed ? 0.5 : 1,
//             px: isCollapsed ? 1.5 : 2,
//             py: 1,
//             minHeight: 42,
//             justifyContent: isCollapsed ? "center" : "flex-start",
//             backgroundColor: isActive(item.path) ? SIDEBAR_ACTIVE : "transparent",
//             color: isActive(item.path) ? SIDEBAR_TEXT_ACTIVE : SIDEBAR_TEXT,
//             "&:hover": {
//               backgroundColor: isActive(item.path) ? SIDEBAR_ACTIVE : SIDEBAR_HOVER,
//               color: SIDEBAR_TEXT_ACTIVE,
//             },
//           }}
//         >
//           <ListItemIcon
//             sx={{
//               color: isActive(item.path) ? SIDEBAR_TEXT_ACTIVE : SIDEBAR_TEXT,
//               minWidth: isCollapsed ? 0 : 36,
//               mr: isCollapsed ? 0 : 1,
//             }}
//           >
//             {item.icon}
//           </ListItemIcon>

//           {!isCollapsed && (
//             <ListItemText
//               primary={item.text}
//               primaryTypographyProps={{
//                 fontSize: 13,
//                 fontWeight: isActive(item.path) ? 600 : 400,
//               }}
//             />
//           )}
//         </ListItemButton>
//       </ListItem>
//     );

//     return isCollapsed ? (
//       <Tooltip title={item.text} placement="right">{button}</Tooltip>
//     ) : button;
//   };

//   /* ================= COLLAPSIBLE ================= */

//   const CollapsibleSection = ({ title, icon, sectionKey, items }) => (
//     <>
//       <ListItem disablePadding>
//         <ListItemButton
//           onClick={() =>
//             setOpenSection(openSection === sectionKey ? null : sectionKey)
//           }
//           sx={{
//             borderRadius: "8px",
//             mx: 1,
//             py: 1,
//             color: SIDEBAR_TEXT,
//             "&:hover": { backgroundColor: SIDEBAR_HOVER },
//           }}
//         >
//           <ListItemIcon sx={{ color: SIDEBAR_TEXT }}>{icon}</ListItemIcon>

//           {!isCollapsed && (
//             <>
//               <ListItemText primary={title} />
//               {openSection === sectionKey ? <ExpandLess /> : <ExpandMore />}
//             </>
//           )}
//         </ListItemButton>
//       </ListItem>

//       {!isCollapsed && (
//         <Collapse in={openSection === sectionKey}>
//           <List sx={{ pl: 2 }}>
//             {items.map((item) => (
//               <NavItem key={item.text} item={item} />
//             ))}
//           </List>
//         </Collapse>
//       )}
//     </>
//   );

//   /* ================= SIDEBAR ================= */

//   const list = () => (
//     <Box
//       sx={{
//         width: isMobile ? 280 : drawerWidth,
//         height: "100vh",
//         display: "flex",
//         flexDirection: "column",
//         backgroundColor: SIDEBAR_BG,
//       }}
//     >

//       {/* Logo */}
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           px: 2,
//           py: 2,
//           borderBottom: `1px solid ${SIDEBAR_BORDER}`,
//         }}
//       >
//         <img src={ClinicLogo} alt="logo" style={{ height: 28 }} />
//       </Box>

//       {/* Menu */}
//       <Box sx={{ flex: 1, overflowY: "auto", py: 1 }}>
//         <List disablePadding>
//           {commonItems.map((item) => (
//             <NavItem key={item.text} item={item} />
//           ))}
//         </List>

//         {(LoginUserType === "admin" || LoginUserType === "super_admin") && (
//           <>
//             <Divider sx={{ borderColor: SIDEBAR_BORDER, my: 1 }} />

//             <List disablePadding>

//               <CollapsibleSection
//                 title="Rite Management"
//                 icon={<HealingIcon />}
//                 sectionKey="rite"
//                 items={riteItems}
//               />

//               <NavItem
//                 item={{
//                   text: "Enquiries",
//                   icon: <Diversity3Icon />,
//                   path: `${basePath}/all-enquiries`,
//                 }}
//               />

//             </List>
//           </>
//         )}
//       </Box>

//       {/* Profile + Logout */}
//       <Box sx={{ borderTop: `1px solid ${SIDEBAR_BORDER}`, p: 1.5 }}>

//         {!isCollapsed && (
//           <ListItemButton
//             component={Link}
//             to={`${basePath}/user-profile`}
//             sx={{ borderRadius: 2, mb: 1 }}
//           >
//             <Avatar
//               sx={{
//                 width: 36,
//                 height: 36,
//                 backgroundColor: "rgba(46,196,165,0.2)",
//                 color: TEAL_ACCENT,
//                 mr: 1.5,
//               }}
//             >
//               {client?.legal_name?.[0]?.toUpperCase() || "U"}
//             </Avatar>

//             <Box>
//               <Typography sx={{ fontSize: 13, color: "#fff", fontWeight: 600 }}>
//                 {fullName}
//               </Typography>
//               <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.4)" }}>
//                 {LoginUserType}
//               </Typography>
//             </Box>
//           </ListItemButton>
//         )}

//         <ListItemButton
//           onClick={() => setOpenLogoutDialog(true)}
//           sx={{
//             borderRadius: 2,
//             color: "rgba(255,255,255,0.4)",
//             "&:hover": { color: "#ef4444" },
//           }}
//         >
//           <PowerSettingsNewIcon sx={{ mr: isCollapsed ? 0 : 1 }} />
//           {!isCollapsed && <Typography sx={{ fontSize: 12 }}>Logout</Typography>}
//         </ListItemButton>
//       </Box>
//     </Box>
//   );

//   return (
//     <Box>

//       {isMobile && (
//         <IconButton
//           onClick={() => setMobileOpen(true)}
//           sx={{
//             position: "fixed",
//             top: 10,
//             left: 10,
//             zIndex: 1300,
//             backgroundColor: SIDEBAR_BG,
//             color: "#fff",
//           }}
//         >
//           <MenuIcon />
//         </IconButton>
//       )}

//       {isMobile ? (
//         <SwipeableDrawer
//           anchor="left"
//           open={mobileOpen}
//           onClose={() => setMobileOpen(false)}
//           onOpen={() => setMobileOpen(true)}
//         >
//           {list()}
//         </SwipeableDrawer>
//       ) : (
//         <Drawer variant="permanent">{list()}</Drawer>
//       )}

//       {/* Logout Dialog */}
//       <Dialog open={openLogoutDialog}>
//         <DialogTitle>Logout</DialogTitle>

//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to logout?
//           </DialogContentText>
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={() => setOpenLogoutDialog(false)}>Cancel</Button>

//           <Button
//             variant="contained"
//             onClick={handleLogoutConfirm}
//             disabled={loading}
//           >
//             {loading ? <CircularProgress size={20} /> : "Logout"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//     </Box>
//   );
// }




import React, { useState } from "react";
import {
  Box, SwipeableDrawer, Drawer, List, Divider, ListItem, ListItemButton,
  ListItemIcon, ListItemText, Typography, Avatar, IconButton, Collapse,
  useMediaQuery, Dialog, DialogActions, DialogContent, DialogContentText,
  DialogTitle, Button, CircularProgress, Tooltip, Chip
} from "@mui/material";
import {
  Dashboard, People, CalendarMonth, Sms, LocationOn, Language, Email,
  PowerSettingsNew, ExpandMore, ExpandLess, Menu as MenuIcon,
  AdminPanelSettings, Category, ContactMail, ChevronLeft, ChevronRight,
  StorefrontOutlined
} from "@mui/icons-material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ClinicLogo from "../../Assets/logo.png";
import {
  getDecryptedData,
  getDecryptedUserType,
} from "../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import Groups2Icon from '@mui/icons-material/Groups2';

const accent = "#0d47a1";
const accentLight = "#e3f2fd";
const SIDEBAR_BG = "linear-gradient(180deg, #061a40 0%, #0a2a6e 100%)";
const SIDEBAR_BG_SOLID = "#071e4a";
const SIDEBAR_HOVER = "rgba(13,71,161,0.25)";
const SIDEBAR_ACTIVE = accent;
const SIDEBAR_TEXT = "rgba(255,255,255,0.65)";
const SIDEBAR_TEXT_ACTIVE = "#fff";
const SIDEBAR_BORDER = "rgba(255,255,255,0.08)";

const DESKTOP_BP = "(min-width:1200px)";
const TABLET_BP = "(min-width:768px) and (max-width:1199px)";
const MOBILE_BP = "(max-width:767px)";

export default function ClientViewSidebar({ onSidebarChange }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [openSection, setOpenSection] = useState(null);

  const clientId = sessionStorage.getItem("activeClientId");
  const isDesktop = useMediaQuery(DESKTOP_BP);
  const isTablet = useMediaQuery(TABLET_BP);
  const isMobile = useMediaQuery(MOBILE_BP);

  const location = useLocation();
  const navigate = useNavigate();

  const LoginUserType = getDecryptedUserType();
  const client = JSON.parse(sessionStorage.getItem("clientDetails") || "{}");
  const fullName = client?.legal_name || "Client";

  const basePath = "/client-view";
  const isCollapsed = isTablet ? true : collapsed;
  const drawerWidth = isCollapsed ? 72 : 260;

  React.useEffect(() => {
    if (onSidebarChange) {
      isMobile ? onSidebarChange(0) : onSidebarChange(drawerWidth);
    }
  }, [drawerWidth, isMobile, onSidebarChange]);

  const handleLogoutConfirm = () => {
    setLoading(true);
    setTimeout(() => {
      sessionStorage.clear();
      navigate("/client-login");
    }, 1500);
  };

  const isActive = (path) => location.pathname === path;

  /* ========== MENU ========== */

  const mainItems = [
    { text: "Dashboard", icon: <Dashboard />, path: `${basePath}/${clientId}/dashboard` },
    { text: "Locations", icon: <LocationOn />, path: `${basePath}/locations/${clientId}` },
    { text: "Staff", icon: <People />, path: `${basePath}/staff/${clientId}` },
    { text: "Orders", icon: <CalendarMonth />, path: `${basePath}/orders/${clientId}` },
    { text: "Customers", icon: <Groups2Icon />, path: `${basePath}/customers/${clientId}` },
  ];

  const marketingItems = [
    { text: "Emails", icon: <Email />, path: `${basePath}/emails/${clientId}` },
    { text: "RCS", icon: <Sms />, path: `${basePath}/rcs/${clientId}` },
    { text: "Websites", icon: <Language />, path: `${basePath}/websites/${clientId}` },
  ];



  /* ========== NAV ITEM ========== */

  const NavItem = ({ item }) => {
    const active = isActive(item.path);

    const btn = (
      <ListItem disablePadding sx={{ mb: 0.3 }}>
        <ListItemButton
          component={Link}
          to={item.path}
          onClick={() => isMobile && setMobileOpen(false)}
          sx={{
            borderRadius: "10px",
            mx: isCollapsed ? 0.75 : 1.25,
            px: isCollapsed ? 1.5 : 2,
            py: 0.9,
            minHeight: 44,
            justifyContent: isCollapsed ? "center" : "flex-start",
            background: active
              ? `linear-gradient(135deg, ${accent}, #1565c0)`
              : "transparent",
            color: active ? SIDEBAR_TEXT_ACTIVE : SIDEBAR_TEXT,
            boxShadow: active ? "0 4px 12px rgba(13,71,161,0.35)" : "none",
            "&:hover": {
              background: active
                ? `linear-gradient(135deg, ${accent}, #1565c0)`
                : SIDEBAR_HOVER,
              color: SIDEBAR_TEXT_ACTIVE,
            },
            transition: "all 0.2s ease",
          }}
        >
          <ListItemIcon
            sx={{
              color: active ? "#fff" : SIDEBAR_TEXT,
              minWidth: isCollapsed ? 0 : 36,
              mr: isCollapsed ? 0 : 1.5,
              transition: "color 0.2s",
            }}
          >
            {item.icon}
          </ListItemIcon>
          {!isCollapsed && (
            <ListItemText
              primary={item.text}
              primaryTypographyProps={{
                fontSize: 13.5,
                fontWeight: active ? 600 : 400,
                letterSpacing: 0.2,
              }}
            />
          )}
        </ListItemButton>
      </ListItem>
    );

    return isCollapsed ? (
      <Tooltip title={item.text} placement="right" arrow>
        {btn}
      </Tooltip>
    ) : (
      btn
    );
  };

  /* ========== SECTION LABEL ========== */

  const SectionLabel = ({ label }) =>
    !isCollapsed ? (
      <Typography
        sx={{
          fontSize: 10,
          fontWeight: 700,
          color: "rgba(255,255,255,0.3)",
          textTransform: "uppercase",
          letterSpacing: 1.5,
          px: 2.5,
          pt: 2,
          pb: 0.5,
        }}
      >
        {label}
      </Typography>
    ) : (
      <Divider sx={{ borderColor: SIDEBAR_BORDER, my: 1, mx: 1 }} />
    );

  /* ========== COLLAPSIBLE ========== */

  const CollapsibleSection = ({ title, icon, sectionKey, items }) => (
    <>
      <ListItem disablePadding>
        <ListItemButton
          onClick={() => setOpenSection(openSection === sectionKey ? null : sectionKey)}
          sx={{
            borderRadius: "10px",
            mx: isCollapsed ? 0.75 : 1.25,
            py: 0.9,
            color: SIDEBAR_TEXT,
            "&:hover": { background: SIDEBAR_HOVER, color: SIDEBAR_TEXT_ACTIVE },
          }}
        >
          <ListItemIcon sx={{ color: SIDEBAR_TEXT, minWidth: isCollapsed ? 0 : 36, mr: isCollapsed ? 0 : 1.5 }}>
            {icon}
          </ListItemIcon>
          {!isCollapsed && (
            <>
              <ListItemText primary={title} primaryTypographyProps={{ fontSize: 13.5 }} />
              {openSection === sectionKey ? <ExpandLess /> : <ExpandMore />}
            </>
          )}
        </ListItemButton>
      </ListItem>
      {!isCollapsed && (
        <Collapse in={openSection === sectionKey}>
          <List sx={{ pl: 1 }}>
            {items.map((item) => (
              <NavItem key={item.text} item={item} />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );

  /* ========== DRAWER CONTENT ========== */

  const list = () => (
    <Box
      sx={{
        width: isMobile ? 280 : drawerWidth,
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        background: SIDEBAR_BG,
        transition: "width 0.3s ease",
      }}
    >
      {/* Logo & Toggle */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: isCollapsed ? "center" : "space-between",
          px: isCollapsed ? 1 : 2,
          py: 2,
          borderBottom: `1px solid ${SIDEBAR_BORDER}`,
          minHeight: 64,
        }}
      >
        {!isCollapsed && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <img src={ClinicLogo} alt="logo" style={{ height: 30 }} />
            {/* <Typography sx={{ fontSize: 16, fontWeight: 800, color: "#fff", letterSpacing: 0.5 }}>
              Rite<span style={{ color: accentLight }}>.</span>
            </Typography> */}
          </Box>
        )}
        {!isMobile && (
          <IconButton
            onClick={() => setCollapsed(!collapsed)}
            sx={{ color: SIDEBAR_TEXT, "&:hover": { color: "#fff" } }}
            size="small"
          >
            {isCollapsed ? <ChevronRight fontSize="small" /> : <ChevronLeft fontSize="small" />}
          </IconButton>
        )}
      </Box>

      {/* Menu */}
      <Box sx={{ flex: 1, overflowY: "auto", py: 1, "&::-webkit-scrollbar": { width: 4 }, "&::-webkit-scrollbar-thumb": { background: "rgba(255,255,255,0.1)", borderRadius: 2 } }}>
        <SectionLabel label="Main" />
        <List disablePadding>
          {mainItems.map((item) => <NavItem key={item.text} item={item} />)}
        </List>

        <SectionLabel label="Marketing" />
        <List disablePadding>
          {marketingItems.map((item) => <NavItem key={item.text} item={item} />)}
        </List>

        {/* {(LoginUserType === "admin" || LoginUserType === "super_admin") && (
          <>
            <SectionLabel label="Administration" />
            <List disablePadding>
              <CollapsibleSection
                title="Rite Management"
                icon={<AdminPanelSettings />}
                sectionKey="rite"
                items={adminItems}
              />
              <NavItem item={{ text: "Enquiries", icon: <ContactMail />, path: `${basePath}/all-enquiries` }} />
            </List>
          </>
        )} */}
      </Box>

      {/* Profile & Logout */}
      <Box sx={{ borderTop: `1px solid ${SIDEBAR_BORDER}`, p: 1.5 }}>
        {!isCollapsed && (
          <ListItemButton
            component={Link}
            to={`${basePath}/user-profile`}
            sx={{
              borderRadius: "10px",
              mb: 1,
              background: "rgba(13,71,161,0.15)",
              "&:hover": { background: "rgba(13,71,161,0.25)" },
            }}
          >
            <Avatar
              sx={{
                width: 38,
                height: 38,
                background: `linear-gradient(135deg, ${accent}, #1976d2)`,
                color: "#fff",
                fontSize: 16,
                fontWeight: 700,
                mr: 1.5,
              }}
            >
              {fullName[0]?.toUpperCase() || "U"}
            </Avatar>
            <Box sx={{ overflow: "hidden" }}>
              <Typography noWrap sx={{ fontSize: 13, color: "#fff", fontWeight: 600 }}>
                {fullName}
              </Typography>
              {/* <Chip
                label={LoginUserType}
                size="small"
                sx={{
                  height: 18,
                  fontSize: 10,
                  fontWeight: 600,
                  backgroundColor: "rgba(227,242,253,0.15)",
                  color: accentLight,
                  textTransform: "capitalize",
                }}
              /> */}
            </Box>
          </ListItemButton>
        )}

         {isCollapsed && (
          <ListItemButton
            component={Link}
            to={`${basePath}/user-profile`}
            sx={{
              borderRadius: "10px",
              mb: 1,
              
                justifyContent: "center",

            }}
          >
            <Avatar
              sx={{
                width: 38,
                height: 38,
                background: `linear-gradient(135deg, ${accent}, #1976d2)`,
                color: "#fff",
                fontSize: 16,
                fontWeight: 700,
                mr: 1.5,
              }}
            >
              {fullName[0]?.toUpperCase() || "U"}
            </Avatar>
          </ListItemButton>
        )}

        {isCollapsed ? (
          <Tooltip title="Logout" placement="right" arrow>

            <ListItemButton
              onClick={() => setOpenLogoutDialog(true)}
              sx={{
                borderRadius: "10px",
                justifyContent: "center",
                color: "rgba(255,255,255,0.4)",
                "&:hover": { color: "#ef4444", background: "rgba(239,68,68,0.1)" },
              }}
            >
              <PowerSettingsNew />
            </ListItemButton>
          </Tooltip>
        ) : (
          <ListItemButton
            onClick={() => setOpenLogoutDialog(true)}
            sx={{
              borderRadius: "10px",
              color: "rgba(255,255,255,0.4)",
              "&:hover": { color: "#ef4444", background: "rgba(239,68,68,0.1)" },
            }}
          >
            <PowerSettingsNew sx={{ mr: 1.5, fontSize: 20 }} />
            <Typography sx={{ fontSize: 12.5 }}>Logout</Typography>
          </ListItemButton>
        )}
      </Box>
    </Box>
  );

  return (
    <Box>
      {isMobile && (
        <IconButton
          onClick={() => setMobileOpen(true)}
          sx={{
            position: "fixed",
            top: 12,
            left: 12,
            zIndex: 1300,
            background: `linear-gradient(135deg, ${accent}, #1565c0)`,
            color: "#fff",
            boxShadow: "0 4px 12px rgba(13,71,161,0.3)",
            "&:hover": { background: accent },
          }}
        >
          <MenuIcon />
        </IconButton>
      )}

      {isMobile ? (
        <SwipeableDrawer anchor="left" open={mobileOpen} onClose={() => setMobileOpen(false)} onOpen={() => setMobileOpen(true)}>
          {list()}
        </SwipeableDrawer>
      ) : (
        <Drawer variant="permanent" PaperProps={{ sx: { border: "none", overflow: "hidden" } }}>
          {list()}
        </Drawer>
      )}

      {/* Logout Dialog */}
      <Dialog open={openLogoutDialog} PaperProps={{ sx: { borderRadius: 3, minWidth: 340 } }}>
        <DialogTitle sx={{ fontWeight: 700, color: accent }}>Confirm Logout</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to log out of your client portal?</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setOpenLogoutDialog(false)} sx={{ borderRadius: 2, color: "#666" }}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleLogoutConfirm}
            disabled={loading}
            sx={{ borderRadius: 2, background: "#ef4444", "&:hover": { background: "#dc2626" } }}
          >
            {loading ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Logout"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
